import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import MissionSection from './components/MissionSection';
import LeadershipSection from './components/LeadershipSection';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <AboutHero />
        <MissionSection />
        <LeadershipSection />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;